import React from "react";

interface InlineErrorProps {
    message: string;
}

export const InlineError = ({ message }: InlineErrorProps) => (
    <div className="row mb-3">
        <div className="col">
            <div data-testid="inline-error" role="alert" className="alert inline-error p-3">
                {message}
            </div>
        </div>
    </div>
);
